import React, { useEffect, useMemo, useState } from 'react';

import websitelogo from '../../../../assets/logos/websitelogo.svg';
import logoutPng from '../../../../assets/logos/logoutIcons.png';
import BrandedLoader from '../../../components/BrandedLoader/BrandedLoader';

import './SelectPracticev2.css';

import {
	Avatar,
	Badge,
	Box,
	Button,
	IconButton,
	InputBase,
	Menu,
	MenuItem,
	Modal,
	Typography,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import TuneIcon from '@mui/icons-material/Tune';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import MoreVertRoundedIcon from '@mui/icons-material/MoreVertRounded';
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded';
import HighlightOffRoundedIcon from '@mui/icons-material/HighlightOffRounded';
import MonetizationOnOutlinedIcon from '@mui/icons-material/MonetizationOnOutlined';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import ApartmentRoundedIcon from '@mui/icons-material/ApartmentRounded';
import FavoriteBorderRoundedIcon from '@mui/icons-material/FavoriteBorderRounded';
import LocalHospitalRoundedIcon from '@mui/icons-material/LocalHospitalRounded';
import MailOutlineOutlinedIcon from '@mui/icons-material/MailOutlineOutlined';
import LanguageIcon from '@mui/icons-material/Language';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import { Feedback } from '@mui/icons-material';
import { Link, useNavigate } from 'react-router-dom';

import { getPractices, getVisitCount, logout } from '../../../services/api/apiManager';
import { useStateValue } from '../../../services/state/State';
import { actions } from '../../../services/state/Reducer';
import FeedbackPopup from '../../../main/accounts/feedback/FeedbackPopup';

const modalStyle = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: 500,
	backgroundColor: 'white',
	border: '1px solid #00000026',
	p: 4,
	borderRadius: '10px',
};

const statConfig = [
	{
		key: 'approved',
		label: 'Approved',
		status: 'A',
		className: 'approved',
		icon: CheckCircleOutlineRoundedIcon,
		subtitle: 'Approved Visits',
	},
	{
		key: 'draft',
		label: 'Draft',
		status: 'D',
		className: 'draft',
		icon: AccessTimeRoundedIcon,
		subtitle: 'Draft Visits',
	},
	{
		key: 'rejected',
		label: 'Rejected',
		status: 'O',
		className: 'rejected',
		icon: HighlightOffRoundedIcon,
		subtitle: 'Rejected Visits',
	},
	{
		key: 'billed',
		label: 'Billed',
		status: 'B',
		className: 'billed',
		icon: MonetizationOnOutlinedIcon,
		subtitle: 'Billed Visits',
	},
];

const practiceIcons = [
	BusinessOutlinedIcon,
	ApartmentRoundedIcon,
	FavoriteBorderRoundedIcon,
	LocalHospitalRoundedIcon,
];

const practiceIconClasses = ['blue', 'green', 'purple', 'orange', 'teal', 'rose'];

const getCountByStatus = (visitcounts, practiceId, status) => {
	if (!visitcounts?.length) {
		return 0;
	}

	const matched = visitcounts.find(
		(item) => item?.id == practiceId && item?.Status === status
	);

	return matched?.cnt || 0;
};

export const logoutFunc = async () => {
	const refreshToken = { refresh_token: localStorage.getItem('refreshtoken') };
	localStorage.removeItem('accessToken');
	localStorage.removeItem('user');
	localStorage.removeItem('refreshtoken');
	localStorage.removeItem('loginTime');
	localStorage.removeItem('practice_id');
	localStorage.removeItem('userName');
	localStorage.removeItem('prName');
	localStorage.removeItem('OSW_id');
	localStorage.removeItem('OID');
	const resp = await logout(refreshToken);
	console.log(resp);
};

function SelectPracticev2() {
	const [searchText, setSearchText] = useState('');
	const [openModal, setOpenModal] = useState(false);
	const [anchorElUser, setAnchorElUser] = useState(null);
	const [loading, setLoading] = useState(false);

	const [{ practices, practicestats }, dispatch] = useStateValue();
	const visitcounts = practicestats?.visits || [];
	const navigate = useNavigate();

	const user = localStorage.getItem('userName') || 'User';

	const fetchPractices = async () => {
		try {
			setLoading(true);
			const response = await getPractices();
			if (response?.status === 200) {
				dispatch({ type: actions.SET_PRACTICES, payload: response?.data });
			} else {
				dispatch({ type: actions.SET_PRACTICES, payload: [] });
			}
			setLoading(false);
		} catch (error) {
			console.error('Error fetching practices:', error);
			setLoading(false);
		}
	};

	const fetchvisitcounts = async () => {
		try {
			const response = await getVisitCount();
			if (response?.status === 200) {
				dispatch({ type: actions.SET_PRACTICE_STATS, payload: response?.data });
			} else {
				dispatch({ type: actions.SET_PRACTICE_STATS, payload: [] });
			}
		} catch (error) {
			console.error('Error fetching practices count:', error);
		}
	};

	useEffect(() => {
		fetchPractices();
		fetchvisitcounts();
	}, []);

	const filteredPracticesData = practices?.filter((item) => {
		return searchText?.toLowerCase() === ''
			? practices
			: item.Name && item.Name.toLowerCase().includes(searchText.toLowerCase());
	});

	const practiceSummaries = useMemo(() => {
		return (filteredPracticesData || []).map((practice) => {
			const stats = statConfig.map((entry) => ({
				...entry,
				value: getCountByStatus(visitcounts, practice?.id, entry.status),
			}));

			const total = stats.reduce((sum, item) => sum + item.value, 0);

			return { practice, stats, total };
		});
	}, [filteredPracticesData, visitcounts]);

	const mostActivePracticeId = useMemo(() => {
		if (!practiceSummaries.length) {
			return null;
		}

		return [...practiceSummaries].sort((a, b) => b.total - a.total)[0]?.practice?.id;
	}, [practiceSummaries]);

	const handlepractice = (practice) => {
		dispatch({ type: actions.SET_SELECTED_PRACTICE, payload: practice });
		localStorage.setItem('practice_id', practice?.id);
		localStorage.setItem('prName', practice?.Name);
		localStorage.setItem('OSW_id', practice?.OSW_id);
		localStorage.setItem('OID', practice?.OID);
		navigate('/dashboard');
	};

	const handleEditProvider = () => {
		setOpenModal(true);
	};

	const handleCloseEditModal = () => {
		setOpenModal(false);
	};

	const handleOpenUserMenu = (event) => {
		setAnchorElUser(event.currentTarget);
	};

	const handleCloseUserMenu = () => {
		setAnchorElUser(null);
	};

	const userInitials = user
		.split(' ')
		.filter(Boolean)
		.slice(0, 2)
		.map((part) => part[0]?.toUpperCase())
		.join('');

	return (
		<Box className="select-practice-page">
			<Box className="select-practice-shell">
				<Box className="select-practice-header">
					<Box className="select-practice-header-brand">
						<img src={websitelogo} alt="MaxCharts" />
					</Box>

					<Box className="select-practice-header-actions">
						

						<Button className="select-practice-user-button" onClick={handleOpenUserMenu}>
							<Avatar className="select-practice-user-avatar">{userInitials || 'AI'}</Avatar>
							<Box className="select-practice-user-copy">
								<Typography component="span">{user}</Typography>
							</Box>
							<KeyboardArrowDownIcon />
						</Button>
					</Box>
				</Box>

				<Menu
					sx={{ mt: '45px' }}
					id="menu-appbar"
					anchorEl={anchorElUser}
					anchorOrigin={{
						vertical: 'top',
						horizontal: 'right',
					}}
					keepMounted
					transformOrigin={{
						vertical: 'top',
						horizontal: 'right',
					}}
					open={Boolean(anchorElUser)}
					onClose={handleCloseUserMenu}
				>
					<MenuItem sx={{ flexDirection: 'column' }} onClick={handleEditProvider}>
						<Box
							width={'100%'}
							gap={1}
							display={'flex'}
							justifyContent={'center'}
							alignItems={'center'}
						>
							<Feedback fontSize="10px" />
							<Typography
								width={'60%'}
								textAlign={'start'}
								color={'#404040'}
								fontSize={'12px'}
								fontWeight={400}
							>
								Feedback
							</Typography>
						</Box>
					</MenuItem>
					<Modal
						open={openModal}
						onClose={handleCloseEditModal}
						aria-labelledby="edit-modal-title"
						aria-describedby="edit-modal-description"
						sx={{
							'& .MuiModal-backdrop': {
								opacity: '30 !important',
							},
						}}
					>
						<Box sx={modalStyle}>
							<FeedbackPopup onClose={handleCloseEditModal} />
						</Box>
					</Modal>

					<MenuItem
						sx={{ flexDirection: 'column' }}
						onClick={() => {
							logoutFunc();
							navigate('/');
						}}
					>
						<Box
							width={'100%'}
							gap={1}
							display={'flex'}
							justifyContent={'center'}
							alignItems={'center'}
						>
							<Box width={'15%'}>
								<img src={logoutPng} alt="logout icon" width={'10px'} />
							</Box>
							<Typography
								width={'60%'}
								textAlign={'start'}
								color={'#404040'}
								fontSize={'12px'}
								fontWeight={400}
							>
								Logout
							</Typography>
						</Box>
					</MenuItem>
				</Menu>

				{loading ? (
					<BrandedLoader
						title="Loading practices"
						text="Preparing your available practice list"
						minHeight="calc(100vh - 180px)"
					/>
				) : practices?.length === 0 ? (
					<Box className="select-practice-empty">
						<Box className="select-practice-empty-card">
							<Typography variant="h3">Thank you!</Typography>
							<Typography className="select-practice-empty-subtitle">
								For signing up in MaxRemind Charts.
							</Typography>
							<Typography className="select-practice-empty-text">
								Your request has been submitted, and our sales team will get back
								to you shortly to complete the enrollment process.
							</Typography>

							<Box className="select-practice-empty-links">
								<Box className="select-practice-empty-link">
									<MailOutlineOutlinedIcon fontSize="small" />
									<Link to="mailto:sales@mremind.com">sales@mremind.com</Link>
								</Box>
								<Box className="select-practice-empty-link">
									<LanguageIcon fontSize="small" />
									<Link
										to="https://www.mremind.com/"
										target="_blank"
										rel="noopener noreferrer"
									>
										mremind.com
									</Link>
								</Box>
								<Box className="select-practice-empty-link">
									<LocalPhoneIcon fontSize="small" />
									<Typography component="span">
										<Link to="tel:+12147363533">(214) 736-3533</Link> or{' '}
										<Link to="tel:+14693469843">(469) 346-9843</Link>
									</Typography>
								</Box>
							</Box>

							<Button
								variant="contained"
								className="select-practice-empty-button"
								onClick={() => {
									logoutFunc();
									navigate('/');
								}}
							>
								Back to login
							</Button>
						</Box>
					</Box>
				) : (
					<Box
						className={`select-practice-page-content ${
							practiceSummaries.length > 1
								? 'select-practice-page-content-wide'
								: ''
						}`}
					>
						<Box className="select-practice-hero">
							<Box className="select-practice-hero-copy">
								<Typography className="select-practice-title">
									Select a Practice
								</Typography>

								<Box className="select-practice-search">
									<SearchIcon />
									<InputBase
										placeholder="Search practice by name..."
										value={searchText}
										onChange={(e) => setSearchText(e.target.value)}
										inputProps={{ 'aria-label': 'search practice by name' }}
									/>
									<IconButton aria-label="search filters">
										<TuneIcon />
									</IconButton>
								</Box>
							</Box>
						</Box>

						<Box
							className={`select-practice-results ${
								practiceSummaries.length > 1
									? 'select-practice-results-multi'
									: 'select-practice-results-single'
							} ${
								practiceSummaries.length > 6
									? 'select-practice-results-scroll'
									: ''
							}`}
						>
							{practiceSummaries.map(({ practice, stats }) => {
								const practiceIndex = Number(practice?.id) || 0;
								const IconComponent =
									practiceIcons[practiceIndex % practiceIcons.length];
								const iconTone =
									practiceIconClasses[
										practiceIndex % practiceIconClasses.length
									];

								return (
									<Button
										key={practice?.id}
										className="select-practice-card"
										onClick={() => handlepractice(practice)}
									>
										<Box className="select-practice-card-top">
											<Box className={`select-practice-card-icon ${iconTone}`}>
												<IconComponent />
											</Box>

											<Box className="select-practice-card-copy">
												<Box className="select-practice-card-title-row">
													<Typography className="select-practice-card-title">
														{practice.Name}
													</Typography>
													{practice?.id === mostActivePracticeId && (
														<Box className="select-practice-card-badge">
															Most Active
														</Box>
													)}
												</Box>
												<Typography className="select-practice-card-subtitle">
													Visit Summary
												</Typography>
											</Box>

											<Box className="select-practice-card-menu">
												<MoreVertRoundedIcon />
											</Box>
										</Box>

										<Box className="select-practice-card-stats">
											{stats.map((item) => (
												<Box
													key={item.key}
													className={`select-practice-card-stat ${item.className}`}
												>
													<Box className={`stat-label-row ${item.className}`}>
														<Box className={`stat-icon-wrap ${item.className}`}>
															<item.icon className="stat-icon" />
														</Box>
														<Box className="stat-copy">
															<Typography className={`stat-label ${item.className}`}>
																{item.subtitle}
															</Typography>
															<Typography className={`stat-value ${item.className}`}>
																{item.value}
															</Typography>
														</Box>
													</Box>
												</Box>
											))}
										</Box>
									</Button>
								);
							})}
						</Box>

						<Box className="select-practice-footer">
							<Typography>
								Showing 1 to {practiceSummaries.length} of {practiceSummaries.length}{' '}
								practices
							</Typography>
						</Box>
					</Box>
				)}
			</Box>
		</Box>
	);
}

export default SelectPracticev2;
